import React, { Component } from "react";
import { Typography, Snackbar, SnackbarContent } from "@material-ui/core";
import { connect } from "react-redux";
import {
    getReportTitles,
    getUserData,
    setFilterJobStage,
    setFilterUserUid,
    setSearchDateFrom,
    setSearchDateTo,
    setReportFilterState,
    setPage,
    setRowsPerPage,
    setReportStatus,
    setSelectedRow,
    setReportEditStatus,
    setStatusChangeModal,
    deleteReport,
    setDeleteStatus,
    setJobID,
    setYear,
    setMonth,
} from "./actions";
import {
    canUpdate,
    canDelete,
    selectReportTitles,
    selectUserNames,
    selectFilterJobStage,
    selectFilterUserUid,
    selectSearchDateFrom,
    selectSearchDateTo,
    selectReportFilterState,
    selectTableData,
    selectPage,
    selectRowsPerPage,
    selectSelectedRow,
    selectChangeReportStatusModal,
    selectDeleteStatus,
    selectReportFilterJobID,
    selectReportYear,
    selectReportMonth,
} from "./selectors";
import "./submittedReportsStyles.css";
import Filters from "./Filters";
import TableData from "./TableData";
import ChangeStatusModal from "./ChangeStatusModal";
import { StyledCard, StyledContent, StyledHeader } from "../../styles";
class DailyWorkSheetList extends Component {
    constructor(props) {
        super(props);
        props.getReportTitles();
        props.getUserData();
    }
    render() {
        const {
            reportTitles,
            users,
            selectedJobStage,
            selectedUser,
            dateFrom,
            dateTo,
            setFilterJobStage,
            setFilterUserUid,
            setSearchDateFrom,
            setSearchDateTo,
            filterState,
            setReportFilterState,
            tableData,
            page,
            rowsPerPage,
            setPage,
            setRowsPerPage,
            selectedRow,
            setSelectedRow,
            setReportStatus,
            setReportEditStatus,
            changeStatusModalInfo,
            setStatusChangeModal,
            deletedStatus,
            deleteReport,
            jobID,
            setJobID,
        } = this.props;
        return (
            <>
                <StyledCard>
                    <StyledHeader>
                        <Typography variant="h5">
                            Daily Worksheet List
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <Filters
                            setYear={this.props.setYear}
                            setMonth={this.props.setMonth}
                            year={this.props.year}
                            month={this.props.month}
                            reportTitles={reportTitles}
                            users={users}
                            jobStage={selectedJobStage}
                            user={selectedUser}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                            setJobStage={setFilterJobStage}
                            setUser={setFilterUserUid}
                            setDateFrom={setSearchDateFrom}
                            setDateTo={setSearchDateTo}
                            jobID={jobID}
                            setJobID={setJobID}
                        />
                    </StyledContent>
                </StyledCard>

                <TableData
                    filterState={filterState}
                    setFilterState={setReportFilterState}
                    tableData={tableData}
                    users={users}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    reportTitles={reportTitles}
                    setStatus={setReportStatus}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    setEditStatus={setReportEditStatus}
                    setModalInfo={setStatusChangeModal}
                    canUpdate={this.props.canUpdate}
                    canDelete={this.props.canDelete}
                    year1={this.props.year}
                    month1={this.props.month}
                />

                <ChangeStatusModal
                    reportTitles={reportTitles}
                    users={users}
                    setEditStatus={setReportEditStatus}
                    setReportStatus={setReportStatus}
                    modalInfo={changeStatusModalInfo}
                    setModalInfo={setStatusChangeModal}
                    deleteReport={deleteReport}
                />

                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={4000}
                    open={
                        deletedStatus.deleteSuccess || deletedStatus.deleteFail
                    }
                    onClose={() => {
                        this.props.setDeleteStatus();
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: deletedStatus.deleteSuccess
                                ? "green"
                                : deletedStatus.deleteFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            deletedStatus.deleteSuccess
                                ? "Report Successfully Deleted"
                                : "Unable to Delete Report, Please Contact System Admin With Report Details"
                        }
                    />
                </Snackbar>
            </>
        );
    }
}
export default connect(
    (store) => {
        return {
            reportTitles: selectReportTitles(store),
            users: selectUserNames(store),
            selectedJobStage: selectFilterJobStage(store),
            selectedUser: selectFilterUserUid(store),
            dateFrom: selectSearchDateFrom(store),
            dateTo: selectSearchDateTo(store),
            filterState: selectReportFilterState(store),
            tableData: selectTableData(store),
            page: selectPage(store),
            rowsPerPage: selectRowsPerPage(store),
            selectedRow: selectSelectedRow(store),
            changeStatusModalInfo: selectChangeReportStatusModal(store),
            deletedStatus: selectDeleteStatus(store),
            jobID: selectReportFilterJobID(store),
            canUpdate: canUpdate(store),
            canDelete: canDelete(store),
            year: selectReportYear(store),
            month: selectReportMonth(store),
        };
    },
    {
        getReportTitles,
        getUserData,
        setFilterJobStage,
        setFilterUserUid,
        setSearchDateFrom,
        setSearchDateTo,
        setReportFilterState,
        setPage,
        setRowsPerPage,
        setReportStatus,
        setSelectedRow,
        setReportEditStatus,
        setStatusChangeModal,
        deleteReport,
        setDeleteStatus,
        setJobID,
        setYear,
        setMonth,
    }
)(DailyWorkSheetList);
